module.exports = __webpack_public_path__ + "components/ski-hire-promo/static/ski-hire--map-4953b3d27bf1ac5cb5fee2d257a7d28d.webp";